import { useEffect, useState } from "react";
import { Snackbar } from "@mui/material";
import Alert from "@mui/material/Alert";
import Slide, { type SlideProps } from "@mui/material/Slide";
import { onMessage } from "firebase/messaging";
import { messaging } from "../firebase";
import { getNotifs } from "../Features/Shared/Push Notifications/PushNotificationSlice";
import { useAppDispatch } from "../hooks";
import { useNavigate } from "react-router-dom";

type NotificationMessage = {
    title: string;
    body:  string;
};

function SlideDownTransition (props: SlideProps) {
    return <Slide {...props} direction="down" />
}

export const GlobalNotification = () => {
    const [notification, setNotification] = useState<NotificationMessage | null>(null);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const unsubscribe = onMessage(messaging, async (payload) => {
            setNotification({
                title: payload.notification?.title ?? "Hirsch Notification",
                body: payload.notification?.body ?? "You have a new notification."
            });
            await dispatch(getNotifs());
        });

        return unsubscribe;
    }, []);

    return (
        <Snackbar
            open={Boolean(notification)}
            autoHideDuration={6000}
            onClose={(_, reason) => {
                if (reason !== "clickaway") {
                    setNotification(null);
                }
            }}
            anchorOrigin={{
                vertical: "top",
                horizontal: 'center',
            }}
            slots={{
                transition: SlideDownTransition
            }}
            sx={{ zIndex: 1600 }}
        >
            {notification ? (
                <Alert
                    severity="info"
                    variant="standard"
                    color="warning"
                    onClick={() => navigate('/Dashboard')}
                    onClose={() => setNotification(null)}
                    sx={{ width: '100%', minWidth: 300, cursor: 'pointer' }}
                >
                    <strong>{notification.title}</strong>
                    <br />
                    {notification.body}
                </Alert>
            ): undefined}
        </Snackbar>
    )
};